import React from 'react'
import Cookies from 'js-cookie'
import GoogleAnalytics from 'react-ga'
import cx from 'classnames'
import moment from 'moment'

const calendlyLink = {
  us: 'https://calendly.com/tanda-demo-us/workforce-demo',
  uk: 'https://calendly.com/tanda-demo-uk/schedule'
}

const CalendlyButton = props => {
  if (!props.country) {
    console.error('CalendlyButton: country is required!')
  }

  const onButtonClick = React.useCallback(() => {
    const month = moment().format('YYYY-MM')
    const date = moment().format('YYYY-MM-DD')
    const url = `${calendlyLink[props.country]}?utm_source=${Cookies.get('utm_source')}&month=${month}&date=${date}`

    // TODO: hide button if SDK doesn't load?
    window.Calendly && window.Calendly.initPopupWidget({
      url,
      prefill: {
        name: props.formValue?.name || '',
        email: props.formValue?.email || '',
        customAnswers: {
          a1: props.formValue?.businessName || '',
          a2: props.formValue?.staffNum || '',
          // TODO: rename this field throughout app.
          // eslint-disable-next-line camelcase
          a3: props.formValue?.mob_num || ''
        }
      }
    })

    GoogleAnalytics.event({
      category: 'calendly',
      action: 'click',
      label: window.location.href
    })

    return false
  }, [props.country, props.formValue])

  return (
    <button
      className={cx([
        'btn',
        'btn__solid',
        'btn__orange',
        props.block ? 'block' : 'inline',
        'mt-6',
        props.block ? '' : 'mr-3',
        'mx-auto'
      ])}
      onClick={onButtonClick}
      type="button"
    >
      {props.buttonText || 'Book a Demo'}
    </button>
  )
}

CalendlyButton.defaultProps = {
  block: false
}

export default CalendlyButton
